import { FunnelStateEnum } from "@/__generated__/types";
import { i18n } from "@/i18n";

export const ORDERED_FUNNEL_STATES: FunnelStateEnum[] = [
  FunnelStateEnum.Lead,
  FunnelStateEnum.LeadDropped,
  FunnelStateEnum.Inquired,
  FunnelStateEnum.InquiredDropped,
  FunnelStateEnum.ApplicationStarted,
  FunnelStateEnum.ApplicationStartedCanceled,
  FunnelStateEnum.ApplicationCanceled,
  FunnelStateEnum.Applied,
  FunnelStateEnum.ApplicationComplete,
  FunnelStateEnum.ApplicationCompleteWithdrawn,
  FunnelStateEnum.Denied,
  FunnelStateEnum.Waitlisted,
  FunnelStateEnum.WaitlistedWithdrawn,
  FunnelStateEnum.Deferred,
  FunnelStateEnum.DeferredWithdrawn,
  FunnelStateEnum.Accepted,
  FunnelStateEnum.AcceptanceDeclined,
  FunnelStateEnum.CommitmentWithdrawn,
  FunnelStateEnum.Committed,
  FunnelStateEnum.Enrolled,
];

export const FUNNEL_STATE_TRANSLATION_KEYS: Record<FunnelStateEnum, string> = {
  [FunnelStateEnum.Committed]: "committed",
  [FunnelStateEnum.Accepted]: "accepted",
  [FunnelStateEnum.AcceptanceDeclined]: "acceptanceDeclined",
  [FunnelStateEnum.Applied]: "applied",
  [FunnelStateEnum.ApplicationCanceled]: "applicationCanceled",
  [FunnelStateEnum.ApplicationComplete]: "applicationComplete",
  [FunnelStateEnum.ApplicationCompleteWithdrawn]:
    "applicationCompleteWithdrawn",
  [FunnelStateEnum.ApplicationStarted]: "applicationStarted",
  [FunnelStateEnum.ApplicationStartedCanceled]: "applicationStartedCanceled",
  [FunnelStateEnum.CommitmentWithdrawn]: "commitmentWithdrawn",
  [FunnelStateEnum.Deferred]: "deferred",
  [FunnelStateEnum.DeferredWithdrawn]: "deferredWithdrawn",
  [FunnelStateEnum.Denied]: "denied",
  [FunnelStateEnum.Enrolled]: "enrolled",
  [FunnelStateEnum.InquiredDropped]: "inquiredDropped",
  [FunnelStateEnum.Lead]: "lead",
  [FunnelStateEnum.LeadDropped]: "leadDropped",
  [FunnelStateEnum.Waitlisted]: "waitlisted",
  [FunnelStateEnum.WaitlistedWithdrawn]: "waitlistedWithdrawn",
  [FunnelStateEnum.Inquired]: "inquired",
};

export const FunnelStateMaps = {
  SIDEBAR: {
    inquired: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
    ],
    applicationStarted: [
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.ApplicationCanceled,
    ],
    applicationComplete: [
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
    ],
    denied: [FunnelStateEnum.Denied],
    waitlisted: [
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
    ],
    deferred: [FunnelStateEnum.Deferred, FunnelStateEnum.DeferredWithdrawn],
    admitted: [FunnelStateEnum.Accepted],
    acceptedDeclined: [FunnelStateEnum.AcceptanceDeclined],
    committed: [FunnelStateEnum.Committed],
    commitmentWithdrawn: [FunnelStateEnum.CommitmentWithdrawn],
    enrolled: [FunnelStateEnum.Enrolled, FunnelStateEnum.Committed],
  },
  FUNNEL: {
    inquired: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationCanceled,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.Committed,
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Enrolled,
    ],
    applied: [
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.Committed,
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Enrolled,
    ],
    admitted: [
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.Committed,
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Enrolled,
    ],
    committed: [
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Committed,
      FunnelStateEnum.Enrolled,
    ],
    enrolled: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
    melted: [FunnelStateEnum.CommitmentWithdrawn],
  },
  COMMUNITY_ADOPTION_CHART: {
    inquired: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationCanceled,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.Committed,
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Enrolled,
    ],
    applied: [
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.Committed,
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Enrolled,
    ],
    admitted: [
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.Committed,
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Enrolled,
    ],
    committed: [
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Committed,
      FunnelStateEnum.Enrolled,
    ],
    enrolled: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
  },
  CHARTS: {
    inquired: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.ApplicationCanceled,
    ],
    applied: [
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
    ],
    admitted: [FunnelStateEnum.Accepted, FunnelStateEnum.AcceptanceDeclined],
    commitmentWithdrawn: [FunnelStateEnum.CommitmentWithdrawn],
    committed: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
  },
  COMMIT_INDEX_CHART: {
    admitsOnly: [
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.CommitmentWithdrawn,
    ],
    admitsOnlyCommitted: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
    allStudents: [
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.ApplicationCanceled,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.Applied,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
    ],
    allStudentsCommitted: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
  },
  RISE_APPLY_INDEX_CHART: {
    allStudents: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.ApplicationCanceled,
    ],
    allStudentsApplied: [
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.Committed,
      FunnelStateEnum.CommitmentWithdrawn,
      FunnelStateEnum.Enrolled,
    ],
  },
  RISE_INDEX_CHART: {
    admitsOnly: [
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.CommitmentWithdrawn,
    ],
    admitsOnlyCommitted: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
    applicantsOnly: [
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.CommitmentWithdrawn,
    ],
    applicantsOnlyCommitted: [
      FunnelStateEnum.Committed,
      FunnelStateEnum.Enrolled,
    ],
    allStudents: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.ApplicationCanceled,
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
      FunnelStateEnum.Accepted,
      FunnelStateEnum.AcceptanceDeclined,
      FunnelStateEnum.CommitmentWithdrawn,
    ],
    allStudentsCommitted: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
  },
  COMMIT_INDEX_LIST: {
    inquired: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
    ],
    applicationStarted: [
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.ApplicationCanceled,
    ],
    applicationComplete: [
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
    ],
    denied: [FunnelStateEnum.Denied],
    waitlisted: [
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
    ],
    deferred: [FunnelStateEnum.Deferred, FunnelStateEnum.DeferredWithdrawn],
    admitted: [FunnelStateEnum.Accepted],
    acceptedDeclined: [FunnelStateEnum.AcceptanceDeclined],
    committed: [FunnelStateEnum.Committed],
    commitmentWithdrawn: [FunnelStateEnum.CommitmentWithdrawn],
    enrolled: [FunnelStateEnum.Enrolled],
  },
  STUDENT_PROFILE: {
    inquired: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.ApplicationCanceled,
    ],
    applied: [
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
    ],
    admitted: [FunnelStateEnum.Accepted, FunnelStateEnum.AcceptanceDeclined],
    committed: [
      FunnelStateEnum.Committed,
      FunnelStateEnum.Enrolled,
      FunnelStateEnum.CommitmentWithdrawn,
    ],
  },
  STUDENT_LIST: {
    inquired: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.ApplicationCanceled,
    ],
    applied: [
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
    ],
    admitted: [FunnelStateEnum.Accepted, FunnelStateEnum.AcceptanceDeclined],
    withdrawn: [FunnelStateEnum.CommitmentWithdrawn],
    committed: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
  },
  CURRENT_FUNNEL_STATE_CHART: {
    inquired: [
      FunnelStateEnum.Lead,
      FunnelStateEnum.LeadDropped,
      FunnelStateEnum.Inquired,
      FunnelStateEnum.InquiredDropped,
      FunnelStateEnum.ApplicationStarted,
      FunnelStateEnum.ApplicationStartedCanceled,
      FunnelStateEnum.ApplicationCanceled,
    ],
    applied: [
      FunnelStateEnum.Applied,
      FunnelStateEnum.ApplicationComplete,
      FunnelStateEnum.ApplicationCompleteWithdrawn,
      FunnelStateEnum.Denied,
      FunnelStateEnum.Waitlisted,
      FunnelStateEnum.WaitlistedWithdrawn,
      FunnelStateEnum.Deferred,
      FunnelStateEnum.DeferredWithdrawn,
    ],
    admitted: [FunnelStateEnum.Accepted, FunnelStateEnum.AcceptanceDeclined],
    commitmentWithdrawn: [FunnelStateEnum.CommitmentWithdrawn],
    committed: [FunnelStateEnum.Committed, FunnelStateEnum.Enrolled],
  },
};

export type FunnelStateMapsType = typeof FunnelStateMaps;
export type FunnelMapName = keyof FunnelStateMapsType;
export type FunnelGroupName = {
  [K in keyof FunnelStateMapsType]: keyof FunnelStateMapsType[K];
}[keyof FunnelStateMapsType];

export function getGroupNames<K extends keyof typeof FunnelStateMaps>(
  mappingKey: K,
): (keyof (typeof FunnelStateMaps)[K])[] {
  return Object.keys(
    FunnelStateMaps[mappingKey],
  ) as (keyof (typeof FunnelStateMaps)[K])[];
}

export type FunnelMapKeys<TMap extends keyof typeof FunnelStateMaps> =
  keyof (typeof FunnelStateMaps)[TMap];

export const translateGroupName = (group: FunnelGroupName) =>
  i18n.t(`funnelGroups.${group}`);

type ReverseFunnelMapping = Partial<Record<FunnelStateEnum, FunnelGroupName[]>>;

export const getFunnelStateEnumToGroup = (
  FunnelStateMaps: Record<string, Record<string, FunnelStateEnum[]>>,
) => {
  return Object.entries(FunnelStateMaps).reduce(
    (acc, [mapName, groupMap]) => {
      acc[mapName as FunnelMapName] = Object.entries(groupMap).reduce(
        (acc, [group, enums]) => {
          for (const funnelState of enums) {
            const existing = acc[funnelState] ?? [];
            existing.push(group as FunnelGroupName);
            acc[funnelState] = existing;
          }
          return acc;
        },
        {} as ReverseFunnelMapping,
      );
      return acc;
    },
    {} as Record<FunnelMapName, ReverseFunnelMapping>,
  );
};

export function groupStatesByFunnelGroup<T extends FunnelMapName>(
  data: { state: FunnelStateEnum; value: number }[],
  context: T,
): Record<keyof (typeof FunnelStateMaps)[T], number> {
  const result = {} as Record<keyof (typeof FunnelStateMaps)[T], number>;

  for (const item of data) {
    const groups = FunnelStateEnumToGroup[context][item.state] ?? [];
    for (const group of groups) {
      const key = group as keyof (typeof FunnelStateMaps)[T];
      result[key] = (result[key] ?? 0) + item.value;
    }
  }

  return result;
}

export const FunnelStateEnumToGroup =
  getFunnelStateEnumToGroup(FunnelStateMaps);

const eqSet = <T>(xs: Set<T>, ys: Set<T>) =>
  xs.size === ys.size && [...xs].every((x) => ys.has(x));

/*
 * Attempt to cleanly convert a group of funnel states into another group
 * or throw an exception if it's not possible
 */
export const convertFunnelStatesGroups = <
  T extends FunnelMapName,
  K extends FunnelMapName,
>(
  groupNames: FunnelMapKeys<T>[],
  inputMapName: T,
  outputMapName: K,
): FunnelMapKeys<K>[] => {
  // get all funnel state enum values from currentGroups
  const inputEnums = groupNames.reduce((acc, cur) => {
    const enums = FunnelStateMaps[inputMapName][cur] as FunnelStateEnum[];
    acc.push(...enums);
    return acc;
  }, [] as FunnelStateEnum[]);

  // get all groups in target mapping that these enums are part of
  const outputGroups: FunnelMapKeys<K>[] = [];
  // keep track of all backend funnel states that are in the destination groups
  const funnelStateSet = new Set<FunnelStateEnum>();

  for (const [group, enums] of Object.entries(FunnelStateMaps[outputMapName])) {
    for (const inputEnum of inputEnums) {
      if (enums.includes(inputEnum)) {
        outputGroups.push(group as FunnelMapKeys<K>);

        enums.forEach((item) => funnelStateSet.add(item));
        break;
      }
    }
  }

  // make sure all enum states match between the 2 sets of groups
  if (eqSet(funnelStateSet, new Set(inputEnums))) {
    return outputGroups;
  }

  throw Error("Funnel groups are incompatible.");
};
